import Vue from 'vue'
import VueRouter from 'vue-router'
import { KIOSK_ACTIVATION_KEY, KIOSK_SESSION_KEY } from '@/services/kiosk.service'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'kiosk.login.root',
      meta: { title: 'Kiosk Login', layout: 'kiosk' },
      component: () => import('@/views/Activation.vue')
    },
    {
      path: '/kiosk',
      name: 'kiosk.start.root',
      meta: { title: 'Kiosk', layout: 'kiosk' },
      component: () => import('@/views/Kiosk.vue')
    }
  ]
})

router.beforeEach((to, _from, next) => {
  if (to.path === '/') return next()
  const hasActivation = localStorage.getItem(KIOSK_ACTIVATION_KEY)
  const hasSession = localStorage.getItem(KIOSK_SESSION_KEY)
  if (hasActivation && hasSession) {
    next()
  } else {
    next('/')
  }
})

export default router
